module.exports = __webpack_public_path__ + "static/get-app-f92965685a90bc90b4c8e3336d526ba6.png";